import client from './client';

const PATH = '/api/admin/accounts/users/';

const list = (params = {}) => client.get(PATH, { params }).then((r) => r.data);
const detail = (id) => client.get(`${PATH}${id}/`).then((r) => r.data);

export const usersApi = {
  list,
  detail,

  create(payload) {
    return client.post(PATH, payload).then((r) => r.data);
  },

  update(id, payload) {
    return client.patch(`${PATH}${id}/`, payload).then((r) => r.data);
  },

  remove(id) {
    return client.delete(`${PATH}${id}/`).then((r) => r.data);
  },

  resendInvite(id) {
    return client.post(`${PATH}${id}/resend_invite/`).then((r) => r.data);
  },

  deactivate(id) {
    return client.post(`${PATH}${id}/deactivate/`).then((r) => r.data);
  },

  reactivate(id) {
    return client.post(`${PATH}${id}/reactivate/`).then((r) => r.data);
  },
};

export default usersApi;